uniform vec3 uColor;      // 光条の中心色
uniform vec3 uEdgeColor;  // 端に向かう色（色収差風の青ずれ）
uniform float uIntensity; // 0-1。GSAP でフェード
uniform float uTime;

varying vec2 vUv;

void main()
{
    // 中心原点の座標系（各軸 -1〜1）
    vec2 p = (vUv - 0.5) * 2.0;

    // 横に長く伸びる細いストリーク（アナモルフィックレンズフレア風）
    float horizontal = pow(max(0.0, 1.0 - abs(p.y)), 14.0) * pow(max(0.0, 1.0 - abs(p.x)), 1.5);

    // 細く短い縦のストリークを足して十字に
    float vertical = pow(max(0.0, 1.0 - abs(p.x)), 14.0) * pow(max(0.0, 1.0 - abs(p.y)), 2.5) * 0.45;

    // 中心のコアグロー
    float core = pow(max(0.0, 1.0 - length(p) * 2.2), 3.0);

    // コアのゆらめき（強く光る瞬間がある感じ）
    float shimmer = 0.85 + 0.15 * sin(uTime * 2.4) * sin(uTime * 0.7 + 1.3);

    float streak = horizontal + vertical;

    // 中心は白寄り、外へ行くほど uEdgeColor（青ずれ）に寄せる
    vec3 color = mix(uColor, uEdgeColor, smoothstep(0.05, 0.7, abs(p.x)));
    vec3 finalColor = color * streak * shimmer + uColor * core;

    // 加算ブレンドなので色・アルファ両方に強度を掛ける
    gl_FragColor = vec4(finalColor * uIntensity, (streak + core) * uIntensity);
}
